/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-console */
import PropTypes from 'prop-types';
import {
  React, useEffect, useState, useContext,
} from 'react';
import { DropzoneArea } from 'material-ui-dropzone';
import * as XLSX from 'xlsx';
import SwipeableViews from 'react-swipeable-views';
import { ArrowUpTrayIcon, DocumentTextIcon } from '@heroicons/react/24/outline';
import { useProject } from '../../../config/ProjectContext';
import SimpleAlert from '../../utils/SimpleAlert';
import {
  ERROR_DUPLICATED_SERIALS, ERROR_NO_SERIALS, ERROR_SERIALS_LIMIT, DEPLOY_TYPE_SERIAL,
} from '../../../utils/constants';
import CustomTextArea from '../../utils/CustomTextArea';
import TabPanel, { a11yProps } from '../../TabPanel';
import StagedDeploymentConfig from './StagedDeploymentConfig';
import SelectedObjectsToDeployContext from '../../../config/SelectedAssetsContext';



export default function MachineDeploy({
  setTargets, setType, setMyFiles, values, setValues, renderMyFiles, targets, stagedDeployment, setStagedDeployment, onStagedConfigChange, onLoadingChange,
}) {
  //  alert data
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertHeader, setAlertHeader] = useState('');
  const [alertText, setAlertText] = useState('');

  const { project } = useProject();
  const { selectedObjectsToDeploy } = useContext(SelectedObjectsToDeployContext);

  // DATA RETRIEVAL __________________________
  async function loadType() {
    setType(DEPLOY_TYPE_SERIAL);
  }

  // WEBPAGE______________________________

  // process CSV data
  function openAlert(header, text) {
    setAlertHeader(header);
    setAlertText(text);
    setAlertOpen(true);
  }

  function validateSerial(serialNumber, position) {
    try {
      if (!serialNumber) {
        openAlert('Error', `Line ${position}: Serial ${serialNumber} is empty`);
        return false;
      }
      if (serialNumber.length === 0) {
        openAlert('Error', `Line ${position}: Serial ${serialNumber} must have at list one character`);
        return false;
      }
      // is a string?
      if (typeof serialNumber !== 'string') {
        openAlert('Error', `Line ${position}: Serial ${serialNumber} is not a string`);
        return false;
      }
      return true;
    } catch (error) {
      openAlert('Error validiting Serial');
      return false;
    }
  }

  function hasDuplicates(list) {
    return list.length !== new Set(list).size;
  }

  function processData(rows) {
    if (rows.length === 0) {
      openAlert('Error', ERROR_NO_SERIALS);
      return null;
    }
    if (rows.length > 500) {
      openAlert('Error', ERROR_SERIALS_LIMIT);
      return null;
    }
    const list = [];
    for (let i = 0; i < rows.length; i += 1) {
      const row = rows[i];
      if (!row[0]) {
        openAlert('Error', ERROR_NO_SERIALS);
        return null;
      }
      if (!validateSerial(row[0], i + 1)) {
        return null;
      }
      list.push(row[0]);
    }
    if (hasDuplicates(list)) {
      openAlert('Error', ERROR_DUPLICATED_SERIALS);
      return null;
    }
    return list;
  }

  const handleChangeFile = (files) => {
    const file = files[0];
    const reader = new FileReader();
    reader.onload = (evt) => {
      /* Parse data */
      const bstr = evt.target.result;
      let wb = null;
      try {
        wb = XLSX.read(bstr, { type: 'binary' });
      } catch (error) {
        openAlert('Error', error.message);
      }
      if (wb != null) {
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const list = processData(XLSX.utils.sheet_to_json(ws, { header: 1 }));
        if (list === null) {
          return;
        }
        setTargets(list);
        setMyFiles(files);
      }
    };
    if (file) reader.readAsBinaryString(file);
  };

  useEffect(() => {
    loadType();
  }, [project]);

  const [value, setValue] = useState(0);
  const [serialValues, setSerialValues] = useState('');

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const handleSerialValues = (serialValueParam) => {
    // handle serial values, separated by commas
    const list = serialValueParam.split(',').map((item) => item.trim());
    // delete duplicates and empty spaces
    const uniqueList = [...new Set(list)];
    // give an error if the list has more than 1000 items
    if (uniqueList.length > 1000) {
      openAlert('Error', ERROR_SERIALS_LIMIT);
      return;
    }
    setTargets(uniqueList);
    setSerialValues(serialValueParam);
  };

  const cleanTargetWhenChangeTab = () => {
    setTargets([]);
    setSerialValues('');
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    cleanTargetWhenChangeTab();
  };

  return (
    <div className="bg-gray-50">
      <SimpleAlert open={alertOpen} setOpen={setAlertOpen} header={alertHeader} body={alertText} />
      <div className="bg-white rounded-xl">
        <div className="flex-grow w-full">
          <div className="bg-white">
            <div className="flex border-b border-gray-200">
              <button
                onClick={(e) => handleChange(e, 0)}
                className={`flex-1 py-3 px-4 text-center font-medium text-sm ${
                  value === 0 
                    ? 'text-blue-600 border-b-2 border-blue-600' 
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                <DocumentTextIcon className="w-4 h-4 inline-block mr-2" />
                Serial by text
              </button>
              <button
                onClick={(e) => handleChange(e, 1)}
                className={`flex-1 py-3 px-4 text-center font-medium text-sm ${
                  value === 1 
                    ? 'text-blue-600 border-b-2 border-blue-600' 
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                <ArrowUpTrayIcon className="w-4 h-4 inline-block mr-2" />
                File
              </button>
            </div>
            
            <SwipeableViews
              index={value}
              onChangeIndex={handleChangeIndex}
            >
              <TabPanel value={value} index={0}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6">
                  <div>
                    <div className="bg-white rounded-lg">
                      <div className="space-y-3">
                        <h3 className="text-gray-900 text-base leading-5 font-medium">
                          Indicate Device Serial Numbers (max. 500)
                        </h3>
                        <p className="text-sm text-gray-600">
                          Enter the serial numbers separated by commas.
                        </p>
                        <p className="text-sm text-gray-600">
                          Ex: XXXXX, YYYYY
                        </p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <CustomTextArea
                      screenId="inputDeploymentComments-machineDeployment"
                      placeHolder="Serial Numbers"
                      disableSize
                      values={serialValues}
                      setValues={handleSerialValues}
                      isComment
                      rows={4}
                    />
                  </div>
                </div>
              </TabPanel>
              
              <TabPanel value={value} index={1}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6">
                  <div className="p-3">
                    <DropzoneArea
                      acceptedFiles={['.csv, .xls, .xlsx, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values']}
                      dropzoneText="Click or drag and drop your file here."
                      filesLimit={1}
                      showPreviewsInDropzone={false}
                      showAlerts={false}
                      onChange={(files) => handleChangeFile(files)}
                    />
                  </div>
                  
                  <div>
                    <div className="bg-white rounded-lg">
                      <div className="space-y-3">
                        <h3 className="text-gray-900 text-base leading-5 font-medium">
                          Indicate Device Serial Numbers (max. 500)
                        </h3>
                        <p className="text-sm text-gray-600">
                          ✔️ Upload your serial number list in CSV/XLSX format.
                        </p>
                        <p className="text-sm text-gray-600">
                          ✔️ Include a single column with no header.
                        </p>
                        <p className="text-sm text-gray-600">
                          ✔️ List of maximum 500 serial numbers.
                        </p>
                        <p className="text-sm text-gray-600">
                          ✔️ Max filesize allowed = 50 MB
                        </p>
                        {renderMyFiles()}
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
            </SwipeableViews>
          </div>
        </div>
        
        <div className="bg-white rounded-xl">
          <div className="flex justify-end py-4 px-6">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={stagedDeployment}
                onChange={(e) => setStagedDeployment(e.target.checked)}
                disabled={!targets || targets.length === 0}
                className="mr-2"
              />
              Staged Deployment
            </label>
          </div>
        </div>

        <StagedDeploymentConfig
          isEnabled={stagedDeployment}
          deploymentType={DEPLOY_TYPE_SERIAL}
          targets={targets}
          selectedObjectsToDeploy={selectedObjectsToDeploy}
          onConfigChange={onStagedConfigChange}
          isBundleDeployment={selectedObjectsToDeploy?.[0]?.type === 'bundle'}
          onLoadingChange={onLoadingChange}
        />

        <div className="flex flex-col items-center py-4 pb-6">
          <div className="w-full">
            <CustomTextArea
              screenId="inputDeploymentComments-machineDeployment"
              title="Deployment description"
              placeHolder="Comments (optional)"
              size={300}
              values={values}
              setValues={setValues}
              isComment
              rows={4}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

MachineDeploy.propTypes = {
  setTargets: PropTypes.func.isRequired,
  setType: PropTypes.func.isRequired,
  setMyFiles: PropTypes.func.isRequired,
  values: PropTypes.string.isRequired,
  setValues: PropTypes.func.isRequired,
  renderMyFiles: PropTypes.func.isRequired,
  targets: PropTypes.array,
  stagedDeployment: PropTypes.bool.isRequired,
  setStagedDeployment: PropTypes.func.isRequired,
  onStagedConfigChange: PropTypes.func,
  onLoadingChange: PropTypes.func,
};

MachineDeploy.defaultProps = {
  onStagedConfigChange: () => {},
  onLoadingChange: () => {},
};
